import { createSlice } from "@reduxjs/toolkit";

export interface formValuesState {
  fipayTransfer: {
    RecipientTag: string;
    Amount: string;
    Purpose: string;
    TransactionType: string;
    TransactionFee: number;
    beneficiaryIsSaved: boolean;
    startDate: string;
    endDate: string;
    period: string;
    scheduleTransfer: boolean;
  };
  bankTransfer: {
    RecipientFullName: string;
    RecipientBankName: string;
    RecipientBankRoutingNumber: string;
    RecipientBankAccountNumber: string;
    Amount: string;
    Purpose: string;
    TransactionType: string;
    TransactionFee: number;
    beneficiaryIsSaved: boolean;
    startDate: string;
    endDate: string;
    period: string;
    scheduleTransfer: boolean;
  };
  wireTransfer: {
    RecipientLegalName: string;
    RecipientType: string;
    RecipientProfession: string;
    RecipientPhoneNumber: string;
    RecipientCountry: string;
    RecipientAddress: string;
    RecipientState: string;
    RecipientCity: string;
    RecipientSwiftCode: "";
    RecipientIBAN: "";
    Amount: "";
    Purpose: "";
    TransactionFee: number;
    TransactionType: string;
    Website: string;
    GoodsType: string;
    SupportingDoc: File | null;
    Memo: string;
    scheduleTransfer: boolean;
    startDate: string;
    endDate: string;
    period: string;
  };
  payAnyOne: {
    RecipientPhoneNumber: string;
    Amount: string;
    RecipientFullName: string;
    Purpose: string;
    TransactionType: string;
    TransactionFee: number;
    beneficiaryIsSaved: boolean;
    startDate: string;
    endDate: string;
    period: string;
    scheduleTransfer: boolean;
  };
}

export const initialState = {
  fipayTransfer: {
    RecipientTag: "",
    Amount: "",
    Purpose: "",
    TransactionType: "",
    TransactionFee: 0,
    beneficiaryIsSaved: false,
    startDate: "",
    endDate: "",
    period: "",
    scheduleTransfer: false,
  },
  bankTransfer: {
    RecipientFullName: "",
    RecipientBankName: "",
    RecipientBankRoutingNumber: "",
    RecipientBankAccountNumber: "",
    Amount: "",
    Purpose: "",
    TransactionType: "",
    TransactionFee: 0,
    beneficiaryIsSaved: false,
    startDate: "",
    endDate: "",
    period: "",
    scheduleTransfer: false,
  },
  wireTransfer: {
    RecipientLegalName: "",
    RecipientType: "",
    RecipientProfession: "",
    RecipientPhoneNumber: "",
    RecipientCountry: "United States of America",
    RecipientAddress: "",
    RecipientState: "",
    RecipientCity: "",
    Amount: "",
    Purpose: "",
    RecipientSwiftCode: "",
    RecipientIBAN: "",
    TransactionType: "",
    TransactionFee: 0,
    Website: "",
    GoodsType: "",
    SupportingDoc: null,
    Memo: "",
    scheduleTransfer: false,
    startDate: "",
    endDate: "",
    period: "",
  },
  payAnyOne: {
    RecipientPhoneNumber: "",
    Amount: "",
    RecipientFullName: "",
    Purpose: "",
    TransactionType: "",
    TransactionFee: 0,
    beneficiaryIsSaved: false,
    startDate: "",
    endDate: "",
    period: "",
    scheduleTransfer: false,
  },
};

export const formValuesSlice = createSlice({
  name: "formValues",
  initialState,
  reducers: {
    setFormValues: (state, action) => {
      const { fipayTransfer, bankTransfer, wireTransfer, payAnyOne } =
        action.payload;
      return {
        ...state,
        fipayTransfer: { ...state.fipayTransfer, ...fipayTransfer },
        bankTransfer: { ...state.bankTransfer, ...bankTransfer },
        wireTransfer: { ...state.wireTransfer, ...wireTransfer },
        payAnyOne: { ...state.payAnyOne, ...payAnyOne },
      };
    },
    resetFormValues: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const { setFormValues, resetFormValues } = formValuesSlice.actions;
export default formValuesSlice.reducer;
